"use client";
import Link from 'next/link';
import BlogCard from './BlogCard';
import styles from './styles.module.scss';
import { useEffect, useState } from 'react';


const LatestNews = props => {
    const [latestNewsData, setLatestNewsData] = useState([]);
    const { newsItems, title, showLatest } = props || {};

    const fetchLatestNews = async () => {
        try {
            const res = await fetch('/api/news', {
                method: 'GET',
                next: { revalidate: 360 },
            });
    
            if (!res.ok) {
                console.error("API Error", res);
                return [];
            }
    
            const data = await res.json();
            setLatestNewsData(data);
            return data;
        } catch (error) {
            console.error("Error fetching latest news:", error);
            return [];
        }
    };
    useEffect(()=>{
        fetchLatestNews();
    }, [])
    const renderHeadline = () => (
        <h2 className={styles.blogCallout__headline}>
            {title || "What's New"}
        </h2>
    );

    const renderCards = () => {
        const itemsToShow = showLatest || !newsItems?.length ? latestNewsData : newsItems;

        return itemsToShow && itemsToShow.map((item, index) => {
            const data = item?.newsItem?.edges?.length > 0 ? item?.newsItem?.edges[0] : item;
            return <BlogCard key={index} {...data} />;
        });
    };

    const renderCta = () => (
        <div className={styles.blogCallout__ctaWrap}>
            <Link href="/resources" className={`${styles.blogCallout__cta} button transparent-fill regular`}>
                Explore More
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050" />
                </svg>
            </Link>
        </div>
    );

    return (
        <section className={styles.blogCallout}>
            <div className="container">
                <div className={styles.blogCallout__inner}>
                    {renderHeadline()}
                    <div className={styles.blogCallout__grid}>
                        {renderCards()}
                    </div>
                    {renderCta()}
                </div>
            </div>
        </section>
    );
};

export default LatestNews;
